import { createContext } from "react";
import { AnalyticsBrowser } from "@segment/analytics-next";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const SegmentContext = createContext<AnalyticsBrowser | null>(
  null,
);
